import withAuth from "../../components/auth";
import { injectIntl } from "react-intl";

function CallsNew() {
  return (
    <>
      <edit-call />
    </>
  );
}

export default injectIntl(withAuth(CallsNew));
